"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Panel = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../utils/classNames");
const MediaRenderer_1 = require("../templates/MediaRenderer");
const Panel = (props) => {
    const { children, background } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "relative h-full md:grid md:items-center", children: [background && ((0, jsx_runtime_1.jsx)("div", { className: "absolute inset-0 h-full w-full", children: (0, jsx_runtime_1.jsx)(MediaRenderer_1.MediaRenderer, { media: background, component: (mediaProps) => ((0, jsx_runtime_1.jsx)("img", { src: mediaProps.src, className: (0, classNames_1.cn)('h-full', 'w-full', 'object-cover ', 'object-center'), width: mediaProps.width, height: mediaProps.height, alt: "" })) }) })), (0, jsx_runtime_1.jsx)("div", { children: children })] }));
};
exports.Panel = Panel;
